package ahlers.presence.web.client.resume

/**
 * @author <a href="mailto:michael@ahlers.consulting">Michael Ahlers</a>
 * @since February 07, 2021
 */
case class ExperienceBriefIndex(toInt: Int) extends AnyVal
